import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#FDF8F0] px-4 py-12 md:py-20 overflow-hidden" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        {/* Main Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-59">
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wide text-[#C4704B] bg-[#C4704B]/10 rounded-full" data-id="element-60">
            Para padres de niños de 2 a 9 años
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-[#1B2A4A] leading-[1.1] mb-6 font-serif" data-id="element-61">
            Desconecta las pantallas sin pelear
          </h1>
          <p className="text-lg md:text-xl text-[#4A5568] leading-relaxed max-w-2xl mx-auto" data-id="element-62">
            El plan paso a paso para padres que ya se cansaron de negociar con
            pantallas.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mb-12 rounded-2xl overflow-hidden shadow-2xl border-4 border-white rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/ct9QrrAfTdXbX9mWAEJcpr/Reset_Familiar_7_dias_menos_pantallas.png" alt="Reset Familiar 7 Días Guide on Tablet" className="w-full h-auto object-cover" data-id="element-64" />
        </motion.div>

        {/* Emotional Hook */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg mx-auto text-[#1B2A4A] mb-10" data-id="element-65">
          <p className="font-serif text-2xl italic text-[#C4704B] mb-6 border-l-4 border-[#C4704B] pl-4" data-id="element-66">
            "Hay un momento exacto que te rompe."
          </p>
          <p className="mb-4" data-id="element-67">
            No es cuando tu hijo ve la pantalla. Es cuando se termina.
          </p>
          <p className="mb-4" data-id="element-68">
            Porque tú no apagas un video. Tú apagas…{' '}
            <strong data-id="element-69">la paz que compraste por unos minutos.</strong>
          </p>
          <p className="mb-4" data-id="element-70">Y cuando dices "ya", pasa lo de siempre:</p>
          <ul className="list-none pl-0 space-y-2 mb-6 font-medium text-[#C4704B]" data-id="element-71">
            <li data-id="element-72">“¡Uno más!”</li>
            <li data-id="element-73">“¡Noooo!”</li>
          </ul>
          <p className="mb-8" data-id="element-74">
            Llanto, gritos, negociación, culpa… y al final terminas haciendo lo
            que juraste que no ibas a hacer: ceder, distraer, o explotar.
          </p>
          <p className="font-medium text-xl" data-id="element-75">
            Este PDF existe para una sola cosa: que apagar una pantalla deje de
            ser una pelea diaria.
          </p>
        </motion.div>

        {/* CTA */}
        <div className="text-center" data-id="element-76">
          <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-[#C4704B] rounded-full shadow-lg hover:bg-[#A85A38] hover:scale-105 transition-all duration-300 w-full md:w-auto" data-id="element-77">
            Quiero el Plan
          </a>
          <p className="mt-3 text-sm text-[#4A5568]" data-id="element-78">
            Pago único • Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}